import { render, staticRenderFns } from "./FreshRelevancePixel.vue?vue&type=template&id=6db304c2&scoped=true&"
import script from "./FreshRelevancePixel.vue?vue&type=script&lang=js&"
export * from "./FreshRelevancePixel.vue?vue&type=script&lang=js&"
import style0 from "./FreshRelevancePixel.vue?vue&type=style&index=0&id=6db304c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db304c2",
  null
  
)

export default component.exports